import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Doughnut from '../Doughnut';
import theme, {getUsageStyle} from '../../../theme-config';

export class DoughnutWithContentAndFill extends Component {
  render() {
    const {
      size,
      label,
      isActive,
      current,
      max,
      borderColor,
      textColor,
      iconColor,
    } = this.props;
    const {gradientColors, icon} = getUsageStyle(label, theme);
    return (
      <Doughnut max={max} current={current} color={borderColor} size={size}>
        {isActive ? (
          <Doughnut.Filled size={size - 5} colors={gradientColors}>
            <Doughnut.Content label={label} color="white" icon={icon} />
          </Doughnut.Filled>
        ) : (
          <Doughnut.Content
            label={label}
            iconColor={iconColor}
            textColor={textColor}
            icon={icon}
          />
        )}
      </Doughnut>
    );
  }
}

DoughnutWithContentAndFill.propTypes = {
  isActive: PropTypes.bool,
  current: PropTypes.number,
  label: PropTypes.string,
  size: PropTypes.number,
  max: PropTypes.any,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  iconColor: PropTypes.string,
};

export default DoughnutWithContentAndFill;
